/*
 * @Description 组件 实时报警
 * @Author 
 * @Date 
 */
/* HTML */
<template>
	<!-- 设备 index-sub-item start -->
	<div class="index-sub-item sub-item-cbottom">
		<!-- sub-cbottom-box -->
		<div class="sub-item-box sub-cbottom-box box-alarms-gather">
			<!-- cbottom-content-title start -->
			<div class="cbottom-content-title">实时报警</div>
			<!-- cbottom-content-title end -->
			
			<!-- sub-cbottom-content start -->
			<div class="sub-cbottom-content">
				
				<!-- 轮播 start -->
				<el-carousel v-if="pagination.wholePage > 1" height="100%" :interval="3000" :autoplay="true" arrow="never">
					<el-carousel-item v-for="i in pagination.wholePage" :key="i" >
						
						<!-- sub-cbottom-item start -->
						<div :class="'sub-cbottom-item row-items-'+pagination.limit" v-for="j in pagination.limit" v-if="!$checkEmpty(dataList[(i-1)*pagination.limit+j-1])">
							<div :class="{'cbottom-item-wrap': true, 'cursor-pointer alarm': dataList[(i-1)*pagination.limit+j-1].num > 0}" @click="handleItemBtn(dataList[(i-1)*pagination.limit+j-1])" :title="spliceTitle(dataList[(i-1)*pagination.limit+j-1])">
								<div :class="{'cbottom-item-aname text-over': true, 'fts-18': false}">{{dataList[(i-1)*pagination.limit+j-1].label}}</div>
								<div>
									<img v-if="dataList[(i-1)*pagination.limit+j-1].num > 0" src="~@/static_dazzle/images/alarm.gif"/>
									<img v-else src="~@/static_dazzle/images/alarm_none.gif"/>
								</div>
								<span class="cbottom-item-anum"><b>{{dataList[(i-1)*pagination.limit+j-1].num}}</b><span style="padding-left: 2px;">{{dataList[(i-1)*pagination.limit+j-1].code < 10 ? '人' : '处'}}</span></span>
							</div>
						</div>
						<!-- sub-cbottom-item end -->
						
					</el-carousel-item>
				</el-carousel>
				<!-- 轮播 end -->
				
				<template v-else>
					<!-- sub-cbottom-item start -->
					<div :class="'sub-cbottom-item row-items-'+dataList.length" v-for="(item, index) in dataList">
						<div :class="{'cbottom-item-wrap': true, 'cursor-pointer alarm': item.num > 0}" @click="handleItemBtn(item)" :title="spliceTitle(item)">
							<div :class="{'cbottom-item-aname text-over': true, 'fts-18': false}">{{item.label}}</div>
							<div>
								<img v-if="item.num > 0" src="~@/static_dazzle/images/alarm.gif"/>
								<img v-else src="~@/static_dazzle/images/alarm_none.gif"/>
							</div>
							<span class="cbottom-item-anum"><b>{{item.num}}</b><span style="padding-left: 2px;">{{item.code < 10 ? '人' : '处'}}</span></span>
						</div>
					</div>
					<!-- sub-cbottom-item end -->
				</template>
				
			</div>
			<!-- sub-cbottom-content end -->
		</div>
		<!-- sub-cbottom-box -->
	</div>
	<!-- 设备 index-sub-item end -->
</template>

/* JS */
<script>
	// API 类型
	import ApiType from '@/request/api-type';
	// API 报警
	import ApiAlarm from '@/request/api-alarm';
	// API oam
	import ApiOam from '@/request/api-oam';
	
	export default {
		/**
		 * @Des 组件名
		 * @Auth
		 * @Date 
		 */
        name: "IndRBSiteUser",
        
        /**
		 * @Des 组件注册
		 * @Auth
		 * @Date 
		 */
        components: {
        	
        },// components
        
        /**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	
        },// props
        
        /**
		 * @Des 数据定义
		 * @Auth
		 * @Date 
		 */
		data() {
			return {
				// 数据列表
				dataList: [
					/*
					{code: 2, key: 'invadeAlarm', label: '入界报警', num: 0},
					{code: 3, key: 'outAlarm', label: '出界报警', num: 0},
					{code: 1, key: 'sosAlarm', label: '紧急求助', num: 0},
					{code: 4, key: 'disappearAlarm', label: '消失报警', num: 0},
					{code: 7, key: 'lowPowerAlarm', label: '低电报警', num: 0},
					{code: 8, key: 'fallingAlarm', label: '高空坠落', num: 0},
					{code: 9, key: 'collapseAlarm', label: '塌方砸倒', num: 0},
					*/
					//{code: 5, label: '区域入界报警', num: 4},
					//{code: 6, label: '带离报警', num: 6},
				],
				// 自然灾害
				/*natureDatas: [
					{code: 10, label: '垮塌报警', num: 0},
					{code: 11, label: '沉降报警', num: 0},
					{code: 12, label: '水浸报警', num: 0},
					{code: 13, label: '火灾报警', num: 0},
				],*/
				natureDatas: [],
				// 报警类型 keys
				alarms: [],
				// 报警 list
				alarmList: [],
				// 报警数量
				alarmNums: {},
				// flag 文本溢出
				contentOverFlag: false,
				
				// 定时器
				timer_checkDataInt: null,// 检索数据
				
				/**
				 * @Des 分页组件
				 * @Auth
				 * @Date
				 */
				pagination: {
					total: 0,
					startNum: 0,
					limit: 6,
					currentPage: 1,
					wholePage: 1
				},
				
			}
		},// data
		
		/**
		 * @Des 初始化
		 * @Auth
		 * @Date 
		 */
		created() {
			
		},// created
		
		/**
		 * @Des 加载完成
		 * @Auth
		 * @Date 
		 */
		mounted() {
			// 开启订阅消息
			this.startSubscribes();
			
			// 数据查询
			this.searchData();
		},// mounted
		
		/**
		 * @Des 销毁之前
		 * @Auth
		 * @Date 
		 */
		beforeDestroy() {
			// 取消订阅消息
			this.endSubscribes();
		},// beforeDestroy
		
		/**
		 * @Des 销毁
		 * @Auth
		 * @Date 
		 */
		destroyed() {
			
		},// destroyed
		
		/**
		 * @Des 方法定义
		 * @Auth
		 * @Date 
		 */
		methods: {
			//========================== 订阅消息 start ==========================
			/**
			 * @Des 开启订阅消息
			 * @Auth
			 * @Date
			 */
			startSubscribes() {
				// 订阅消息 详情页
				this.sub_dataChange = this.$pubsub.subscribe('AlarmChange', (name, data) => {
					// 数据查询
					this.searchData();
				});
			},// startSubscribes
			/**
			 * @Des 取消订阅消息
			 * @Auth
			 * @Date
			 */
			endSubscribes() {
				//取消订阅 详情页
				this.$pubsub.unsubscribe(this.sub_dataChange);
			},// endSubscribes
			
			//========================== 订阅消息 end ==========================
			
			/**
			 * @Des 点击条目btn
			 * @Auth
			 * @Date
			 */
			handleItemBtn(row) {
				// 空值 中止
				if (this.$checkEmpty(row) || !(row.num > 0)) {
					return false;
				}
				
				// 点击更多或点击条目报警大于0
				
				// 路由 跳转
				this.$router.replace({path: ('/manager/alarm/real'), query: {alarm: row.code}}, ()=>{}, ()=>{});
			},// handleItemBtn
			
			/**
			 * @Des title 拼接
			 * @Auth
			 * @Date
			 */
			spliceTitle(row) {
				let title = row.label + '：' + row.num + (row.code < 10 ? ' 人' : ' 处');
				if (row.num > 0) {
					title += '\n（点击查看详情）';
				}
				return title;
			},// spliceTitle
			
			//========================== 数据查询 start ==========================
			/**
			 * @Des 数据查询
			 * @Auth 
			 * @Date 
			 */
			searchData(){
				// 数据查询 报警类型
				this.searchAlarmStatus();
			},// searchData
			
			/**
			 * @Des 数据查询 报警类型
			 * @Auth 
			 * @Date 
			 */
			searchAlarmStatus() {
				this.$request.postJsonRequest(ApiType.findTypeApi, {
					projectId: this.$store.state.currentProjectId,
					type: "alarmTypes"
				}).then(result => {
					if(result.code == 0 && result.data.alarmTypes){
						// 数据列表
						let dataList = [];
						// 报警类型 keys
						let alarms = [];
						
						let alarmStatus = Object.assign([], result.data.alarmTypes);
						alarmStatus.forEach((row, index) => {
							// 报警数量
							let num = this.alarmNums[row.state] > 0 ? this.alarmNums[row.state] : 0;
							// 数据列表
							dataList.push({code: row.state,label: row.name,num: num});
							// 报警类型 keys
							alarms.push(row.state);
						});
						// 数据列表
						this.dataList = Object.assign([], [].concat(this.natureDatas).concat(dataList));
						// 报警类型 keys
						this.alarms = Object.assign([], alarms);
						
						// 分页组件
						this.pagination.total = this.dataList.length;
						this.pagination.wholePage = Math.ceil(this.pagination.total / this.pagination.limit);
						
						// 数据查询 报警list
						this.searchAlarm();
					}
				}).catch(error => {
					console.error('查询报警类型异常', ApiType.findTypeApi, error);
				})
			},// searchAlarmStatus
			/**
			 * @Des 数据查询 报警list
			 * @Auth 
			 * @Date 
			 */
			searchAlarm() {
				this.$request.postJsonRequest(ApiOam.Search_Alarm_Uri, {
					projectId: this.$store.state.currentProjectId,
                    dealState: [1],// 0 预警	1 报警	2 已处理
					alarms: this.alarms,// 报警类型 keys
                    orderBy: {
                        alarm_date: 'desc'
                    },
                    total: 0,
                    startNum: 0,
                    limit: 0
				}).then(result => {
					// 数据列表
					//this.dataList[index].num = result.total > 0 ? result.total : 0;
					
					let alarmNums = {};
					// 报警 list
					this.alarmList = !this.$checkEmpty(result.rows) ? Object.assign([], result.rows) : [];
					// 遍历 报警数据list
					this.alarmList.forEach((row, index) => {
						let alarmType = row.alarm;
						// 报警数量
						alarmNums[alarmType] = (alarmNums[alarmType] > 0 ? alarmNums[alarmType] : 0) + 1;
					});
					
					// 报警数量
					this.alarmNums = Object.assign({}, alarmNums);
					// 数据列表
					this.dataList.forEach((row, index) => {
						row.num = alarmNums[row.code] > 0 ? alarmNums[row.code] : 0;
					});
					
					// 排序
					this.dataList.sort((a, b) => {
						return b.num - a.num;
					});
					
				}).catch(error => {
					console.error('查询报警数据异常', ApiOam.Search_Alarm_Uri, error);
				})
			},// searchAlarm
			//========================== 数据查询 end ==========================
			
		},// methods
		
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
		
    }// export default
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_index/IndexItems/IndCBAlarm.vue